import {preload, tileset} from "@frog/source/data/tilesets.js"
import Zone from "@frog/source/models/Zone.js"

function layerKeyFromBlock(block) {
    if(tileset[block.tileKey].layerString != undefined) return "layer: " + tileset[block.tileKey].layerString + ", z:" + block.position.z
    return "z:" + block.position.z
}

const TILESIZE = 96
export default new class Tilesetter {
    constructor() {
        this.canvasContexts = {}
    }
    drawEnvironment({world}) {
        this.canvasContexts = {}

        const tileKeys = {}
        Object.values(world.blocks).forEach((block) => {
            if(tileset[block.tileKey] == undefined) return
            if(this.canvasContexts[layerKeyFromBlock(block)] == undefined) {
                const canvas = document.createElement("canvas")
                this.canvasContexts[layerKeyFromBlock(block)] = canvas.getContext("2d")
                this.canvasContexts[layerKeyFromBlock(block)].canvas.width = world.width * TILESIZE
                this.canvasContexts[layerKeyFromBlock(block)].canvas.height = world.height * TILESIZE
                this.canvasContexts[layerKeyFromBlock(block)].drawOrder = block.position.z
            }

            if(tileKeys[layerKeyFromBlock(block)] == undefined) tileKeys[layerKeyFromBlock(block)] = []
            if(tileKeys[layerKeyFromBlock(block)].includes(block.tileKey) == false) tileKeys[layerKeyFromBlock(block)].push(block.tileKey)
        })

        Object.keys(tileKeys).forEach((layerKey) => {
            const z = parseInt(layerKey.split("z:")[1])
            tileKeys[layerKey].sort((keyA, keyB) => tileset[keyA].drawOrder - tileset[keyB].drawOrder).forEach((tileKey) => {
                const channelSuffix = tileset[tileKey].channelKey == undefined ? "" : "_" + tileset[tileKey].channelKey
                if(tileset[tileKey].grid == "corner") {
                    for(let x = -0.5; x < world.width + 0.5; x += 1) {
                        for(let y = -0.5; y < world.width + 0.5; y += 1) {
                            const position = {
                                "x": x,
                                "y": y,
                                "z": z,
                            }
                            drawCorner({
                                "canvas": this.canvasContexts[layerKeyFromBlock({
                                    "position": position,
                                    "tileKey": tileKey,
                                })],
                                "position": position,
                                "tileKey": tileKey,
                                "world": world,
                                "suffix": channelSuffix,
                            })
                        }
                    }
                } else {
                    for(let x = 0; x < world.width; x += 1) {
                        for(let y = 0; y < world.height; y += 1) {
                            const block = world.blocks[x + "x" + y + "x" + z + channelSuffix]
                            if(block != undefined
                            && block.tileKey == tileKey) {
                                drawTile(this.canvasContexts[layerKeyFromBlock(block)], block, world, channelSuffix)
                            }
                        }
                    }
                }
            })
        })

        return Object.values(this.canvasContexts).sort((a,b) => a.drawOrder - b.drawOrder).map(context => context.canvas.toDataURL())
    }
}

function fillTilesRectangle(context,leftCornerX,topCornerY, width,height) {
    context.fillRect(leftCornerX * TILESIZE,topCornerY * TILESIZE,
        width * TILESIZE,height * TILESIZE)
}
function drawRoughTileLine(context, x1, y1, x2, y2) {
    context.beginPath()
    let ySkew = 0
    let xSkew = 0
    const MARGIN = Math.floor(Math.random() * 15)
    const JITTER = 7
    const JITTER_MEAN = Math.ceil(JITTER/2)
    if(y1 == y2) {
        context.moveTo(Math.floor(x1 * TILESIZE + MARGIN), Math.floor(y1 * TILESIZE + Math.random() * JITTER - JITTER_MEAN))
        context.lineTo(Math.floor(x2 * TILESIZE - MARGIN), Math.floor(y2 * TILESIZE + Math.random() * JITTER - JITTER_MEAN))
    }
    if(x1 == x2) {
        context.moveTo(Math.floor(x1 * TILESIZE + Math.random() * JITTER - JITTER_MEAN), Math.floor(y1 * TILESIZE + MARGIN))
        context.lineTo(Math.floor(x2 * TILESIZE + Math.random() * JITTER - JITTER_MEAN), Math.floor(y2 * TILESIZE - MARGIN))
    }
    context.lineWidth = 4
    context.strokeStyle = `rgba(0,0,0,0.2)`
    context.stroke()
}

const wangEdgeMatch = {
    "4":  {"x": 0, "y": 0},
    "6":  {"x": 1, "y": 0},
    "14": {"x": 2, "y": 0},
    "12": {"x": 3, "y": 0},
    "5":  {"x": 0, "y": 1},
    "7":  {"x": 1, "y": 1},
    "15": {"x": 2, "y": 1},
    "13": {"x": 3, "y": 1},
    "1":  {"x": 0, "y": 2},
    "3":  {"x": 1, "y": 2},
    "11": {"x": 2, "y": 2},
    "9":  {"x": 3, "y": 2},
    "0":  {"x": 0, "y": 3},
    "2":  {"x": 1, "y": 3},
    "10": {"x": 2, "y": 3},
    "8":  {"x": 3, "y": 3},
}

const wangCornerMatch = {
    "15":  {"x": 0, "y": 0},
    "3":  {"x": 1, "y": 0},
    "9": {"x": 2, "y": 0},
    "6": {"x": 3, "y": 0},
    "0":  {"x": 0, "y": 1},
    "12":  {"x": 1, "y": 1},
    "5": {"x": 2, "y": 1},
    "10": {"x": 3, "y": 1},
    "11":  {"x": 0, "y": 2},
    "7":  {"x": 1, "y": 2},
    "4": {"x": 2, "y": 2},
    "8":  {"x": 3, "y": 2},
    "13":  {"x": 0, "y": 3},
    "14":  {"x": 1, "y": 3},
    "2": {"x": 2, "y": 3},
    "1":  {"x": 3, "y": 3},
}

function drawTile(canvas, tile, world, suffix) {
    if(tileset[tile.tileKey] == undefined) return

    const x = tile.position.x
    const y = tile.position.y
    const z = tile.position.z

    const checkOccupancy = (position) => {
        return world.blocks[position.x + "x" + position.y + "x" + z + suffix] != undefined
            && world.blocks[position.x + "x" + position.y + "x" + z + suffix].tileKey == tile.tileKey
    }

    tile.neighbors = {}
    tile.neighbors.hasNorth = checkOccupancy({"x": x, "y": y - 1})
    tile.neighbors.hasEast = checkOccupancy({"x": x + 1, "y": y})
    tile.neighbors.hasSouth = checkOccupancy({"x": x, "y": y + 1})
    tile.neighbors.hasWest = checkOccupancy({"x": x - 1, "y": y})
    tile.wangEdgeIndex = 0
    if(tile.neighbors.hasNorth) tile.wangEdgeIndex += 1
    if(tile.neighbors.hasEast) tile.wangEdgeIndex += 2
    if(tile.neighbors.hasSouth) tile.wangEdgeIndex += 4
    if(tile.neighbors.hasWest) tile.wangEdgeIndex += 8

    if(tileset[tile.tileKey].tilespreadType == "edge-match") {
        const tilesize = tileset[tile.tileKey].tileSize
        const sourceRectangle = {}
        const destinationRectangle = {}

        sourceRectangle.x = wangEdgeMatch[tile.wangEdgeIndex].x * tilesize
        sourceRectangle.y = wangEdgeMatch[tile.wangEdgeIndex].y * tilesize
        destinationRectangle.x = tile.position.x * TILESIZE
        destinationRectangle.y = tile.position.y * TILESIZE

        canvas.globalCompositeOperation = "source-over"
        if(tileset[tile.tileKey].image != undefined) {
            canvas.drawImage(tileset[tile.tileKey].image,
                sourceRectangle.x, sourceRectangle.y, tilesize, tilesize,
                destinationRectangle.x, destinationRectangle.y, TILESIZE, TILESIZE)
        } else if(tileset[tile.tileKey].images != undefined) {
            canvas.drawImage(tileset[tile.tileKey].images[tile.wangEdgeIndex + ""],
                destinationRectangle.x, destinationRectangle.y, TILESIZE, TILESIZE)
        }
    }
    if(tileset[tile.tileKey].tilespreadType == "standalone") {
        canvas.globalCompositeOperation = "source-over"
        canvas.drawImage(tileset[tile.tileKey].image,
            tile.position.x * TILESIZE, tile.position.y * TILESIZE, TILESIZE, TILESIZE)
    }
    if(tileset[tile.tileKey].tilespreadType == undefined
    && tileset[tile.tileKey].tint != undefined) {
        canvas.fillStyle = "rgb(" + tileset[tile.tileKey].tint.R + "," + tileset[tile.tileKey].tint.G + "," + tileset[tile.tileKey].tint.B + ")"
        canvas.globalCompositeOperation = "source-over"
        fillTilesRectangle(canvas, tile.position.x, tile.position.y, 1, 1)
    }
    if(tileset[tile.tileKey].isGridded == true) {
        if(tile.neighbors.hasWest == true) {
            drawRoughTileLine(canvas, tile.position.x, tile.position.y, tile.position.x, tile.position.y + 1)
        }
        if(tile.neighbors.hasNorth == true) {
            drawRoughTileLine(canvas, tile.position.x, tile.position.y, tile.position.x + 1, tile.position.y)
        }
    }
}

function drawCorner({canvas, position, tileKey, world, suffix}) {
    const tilesize = tileset[tileKey].tileSize
    const x = position.x
    const y = position.y
    const z = position.z || 0

    const checkOccupancy = (inputPosition) => {
        return world.blocks[inputPosition.x + "x" + inputPosition.y + "x" + z + suffix] != undefined
            && world.blocks[inputPosition.x + "x" + inputPosition.y + "x" + z + suffix].tileKey == tileKey
    }

    neighbors = {}
    neighbors.hasNorthWest = checkOccupancy({"x": x - 0.5, "y": y - 0.5})
    neighbors.hasNorthEast = checkOccupancy({"x": x + 0.5, "y": y - 0.5})
    neighbors.hasSouthWest = checkOccupancy({"x": x - 0.5, "y": y + 0.5})
    neighbors.hasSouthEast = checkOccupancy({"x": x + 0.5, "y": y + 0.5})
    let wangCornerIndex = 0
    if(neighbors.hasNorthWest) wangCornerIndex += 1
    if(neighbors.hasNorthEast) wangCornerIndex += 2
    if(neighbors.hasSouthEast) wangCornerIndex += 4
    if(neighbors.hasSouthWest) wangCornerIndex += 8
    if(wangCornerIndex == 0) return

    canvas.globalCompositeOperation = "source-over"
    if(tileset[tileKey].image != undefined) {
        canvas.drawImage(tileset[tileKey].image,
            wangCornerMatch[wangCornerIndex].x * tilesize, wangCornerMatch[wangCornerIndex].y * tilesize,
            tilesize, tilesize,
            x * TILESIZE, y * TILESIZE,
            TILESIZE, TILESIZE)
    } else if(tileset[tileKey].images != undefined) {
        canvas.drawImage(tileset[tileKey].images[wangCornerIndex + ""],
            x * TILESIZE, y * TILESIZE,
            TILESIZE, TILESIZE)
    }
}
